import estyled from '@signal/theme/emotion'
import { fadeInUp } from '@signal/utils/animations'
import { getColorBackgroundSelector } from '@signal/theme/selectors'

export const Wrapper = estyled.div`
  display: flex;
  justify-content: ${({ hasAsideContent }) =>
    hasAsideContent ? 'normal' : 'center'};
  &.animateIn {
    ${fadeInUp}
  }
  // background: ${getColorBackgroundSelector('paper')};
`

export const LeftWrapper = estyled.div`
  display: flex;
  flex: 1;
`
export const RightWrapper = estyled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`
